import React from 'react';

const TikTokIcon = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.829 10.5531V6.4595C19.8648 6.4595 18.3658 5.94866 17.3985 4.95362C16.4057 3.81914 15.8494 2.38171 15.8257 0.889144V0.594436L11.8604 0.5V17.1255C11.7243 17.8512 11.3635 18.5186 10.8266 19.037C10.2897 19.5554 9.60264 19.9015 8.85818 20.0276C8.11359 20.1531 7.34748 20.0529 6.66315 19.7399C5.97882 19.4274 5.40926 18.9178 5.03136 18.279C4.65347 17.6408 4.4854 16.9037 4.5499 16.1691C4.61441 15.4352 4.90834 14.7368 5.39206 14.1701C5.87578 13.6042 6.52589 13.196 7.25475 13.0008C7.98361 12.8062 8.75604 12.8348 9.46788 13.0832V9.11886C9.0528 9.05295 8.63308 9.01936 8.21251 9.01873C6.6995 9.01873 5.22044 9.45604 3.96243 10.2762C2.70436 11.0969 1.72384 12.2631 1.14481 13.627C0.565783 14.9915 0.414339 16.493 0.709492 17.9405C1.00465 19.3887 1.73325 20.7197 2.80315 21.7635C3.87298 22.8074 5.2361 23.5185 6.72006 23.8062C8.20401 24.0946 9.74216 23.9469 11.1401 23.3816C12.5379 22.8169 13.7327 21.8599 14.5733 20.6316C15.4139 19.404 15.8626 17.9608 15.8626 16.4841C15.8618 16.178 15.842 15.8725 15.8034 15.5689V8.975C17.6066 10.074 19.7044 10.6235 21.829 10.5531Z"
      fill="currentColor"
    />
  </svg>
);

const BlueskyIcon = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13 10.6489C11.8222 8.27149 8.6164 3.83931 5.6355 1.65495C2.7794 -0.437607 1.6913 -0.0771464 0.9776 0.260363C0.1508 0.645124 0 1.96411 0 2.73768C0 3.51396 0.4095 9.09501 0.676 10.0279C1.56 13.106 4.6982 14.1455 7.592 13.812C3.354 14.4641 -0.4121 16.0666 4.524 21.7746C9.9554 27.6135 11.9678 20.5231 13 16.9279C14.0322 20.5231 15.2204 27.3583 21.3772 21.7746C26 16.9279 22.6473 14.4641 18.4093 13.812C21.3018 14.1455 24.4413 13.106 25.324 10.0279C25.5905 9.09636 26 3.51395 26 2.73903C26 1.96276 25.8492 0.646474 25.0224 0.257663C24.3087 -0.0771465 23.2206 -0.440307 20.3645 1.65225C17.3836 3.84066 14.1765 8.27284 13 10.6489Z"
      fill="currentColor"
    />
  </svg>
);

const InstagramIcon = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.1941 0.824219C9.79414 0.824219 9.37414 0.839219 8.00414 0.899219C6.63914 0.959219 5.71914 1.17922 4.91414 1.49422C4.08414 1.81922 3.38414 2.24922 2.68914 2.94422C1.99414 3.63922 1.56414 4.33922 1.23914 5.16922C0.924141 5.97422 0.704141 6.89422 0.644141 8.25922C0.584141 9.62922 0.569141 10.0492 0.569141 13.4492C0.569141 16.8492 0.584141 17.2692 0.644141 18.6392C0.704141 20.0042 0.924141 20.9242 1.23914 21.7292C1.56414 22.5592 1.99414 23.2592 2.68914 23.9542C3.38414 24.6492 4.08414 25.0792 4.91414 25.4042C5.71914 25.7192 6.63914 25.9392 8.00414 25.9992C9.37414 26.0592 9.79414 26.0742 13.1941 26.0742C16.5941 26.0742 17.0141 26.0592 18.3841 25.9992C19.7491 25.9392 20.6691 25.7192 21.4741 25.4042C22.3041 25.0792 23.0041 24.6492 23.6991 23.9542C24.3941 23.2592 24.8241 22.5592 25.1491 21.7292C25.4641 20.9242 25.6841 20.0042 25.7441 18.6392C25.8041 17.2692 25.8191 16.8492 25.8191 13.4492C25.8191 10.0492 25.8041 9.62922 25.7441 8.25922C25.6841 6.89422 25.4641 5.97422 25.1491 5.16922C24.8241 4.33922 24.3941 3.63922 23.6991 2.94422C23.0041 2.24922 22.3041 1.81922 21.4741 1.49422C20.6691 1.17922 19.7491 0.959219 18.3841 0.899219C17.0141 0.839219 16.5941 0.824219 13.1941 0.824219ZM13.1941 3.14422C16.5441 3.14422 16.9341 3.15422 18.2841 3.21422C19.5341 3.26922 20.2141 3.48422 20.6641 3.66422C21.2641 3.89422 21.6941 4.16922 22.1441 4.61922C22.5941 5.06922 22.8691 5.49922 23.0991 6.09922C23.2791 6.54922 23.4941 7.22922 23.5491 8.47922C23.6091 9.82922 23.6191 10.2192 23.6191 13.5692C23.6191 16.9192 23.6091 17.3092 23.5491 18.6592C23.4941 19.9092 23.2791 20.5892 23.0991 21.0392C22.8691 21.6392 22.5941 22.0692 22.1441 22.5192C21.6941 22.9692 21.2641 23.2442 20.6641 23.4742C20.2141 23.6542 19.5341 23.8692 18.2841 23.9242C16.9341 23.9842 16.5441 23.9942 13.1941 23.9942C9.84414 23.9942 9.45414 23.9842 8.10414 23.9242C6.85414 23.8692 6.17414 23.6542 5.72414 23.4742C5.12414 23.2442 4.69414 22.9692 4.24414 22.5192C3.79414 22.0692 3.51914 21.6392 3.28914 21.0392C3.10914 20.5892 2.89414 19.9092 2.83914 18.6592C2.77914 17.3092 2.76914 16.9192 2.76914 13.5692C2.76914 10.2192 2.77914 9.82922 2.83914 8.47922C2.89414 7.22922 3.10914 6.54922 3.28914 6.09922C3.51914 5.49922 3.79414 5.06922 4.24414 4.61922C4.69414 4.16922 5.12414 3.89422 5.72414 3.66422C6.17414 3.48422 6.85414 3.26922 8.10414 3.21422C9.45414 3.15422 9.84414 3.14422 13.1941 3.14422ZM13.1941 6.44922C9.64414 6.44922 6.76914 9.32422 6.76914 12.8742C6.76914 16.4242 9.64414 19.2992 13.1941 19.2992C16.7441 19.2992 19.6191 16.4242 19.6191 12.8742C19.6191 9.32422 16.7441 6.44922 13.1941 6.44922ZM13.1941 16.9792C10.9241 16.9792 9.08914 15.1442 9.08914 12.8742C9.08914 10.6042 10.9241 8.76922 13.1941 8.76922C15.4641 8.76922 17.2991 10.6042 17.2991 12.8742C17.2991 15.1442 15.4641 16.9792 13.1941 16.9792ZM21.4641 6.17422C21.4641 7.00422 20.7941 7.67422 19.9641 7.67422C19.1341 7.67422 18.4641 7.00422 18.4641 6.17422C18.4641 5.34422 19.1341 4.67422 19.9641 4.67422C20.7941 4.67422 21.4641 5.34422 21.4641 6.17422Z"
      fill="currentColor"
    />
  </svg>
);

const YouTubeIcon = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.1425 12.5627L16.7221 8.79438L10.1425 5.0248V12.5627ZM24.7977 2.72671C24.9635 3.31621 25.0773 4.1083 25.1527 5.11339C25.2425 6.11783 25.2802 6.98483 25.2802 7.73848L25.3562 8.79438C25.3562 11.5452 25.1527 13.5677 24.7977 14.8614C24.4818 15.9922 23.7458 16.7211 22.6054 17.0351C22.0092 17.1979 20.9189 17.3113 19.2454 17.3868C17.5972 17.4748 16.0882 17.5119 14.6943 17.5119L12.6781 17.5875C7.36566 17.5875 4.05701 17.3868 2.75084 17.0351C1.61046 16.7211 0.874471 15.9922 0.558493 14.8614C0.393352 14.2712 0.278911 13.4798 0.203492 12.4747C0.11377 11.4696 0.0760715 10.6033 0.0760715 9.84963L0 8.79438C0 6.04292 0.203506 4.01971 0.558493 2.72671C0.874471 1.5959 1.61046 0.866996 2.75084 0.553027C3.34703 0.389529 4.43733 0.276838 6.11084 0.201277C7.75965 0.11334 9.26802 0.0755592 10.662 0.0755592L12.6781 0C17.9906 0 21.2992 0.201278 22.6054 0.553027C23.7458 0.866996 24.4818 1.5959 24.7977 2.72671Z"
      fill="currentColor"
    />
  </svg>
);

const SocialMediaLinks = ({
  isFooterContentWhite = false,
}: {
  isFooterContentWhite?: boolean;
}): React.ReactElement => {
  const baseTextColor = isFooterContentWhite ? 'text-white' : 'text-black';
  const hoverColor = isFooterContentWhite
    ? 'group-hover:text-[#C3B5FF]'
    : 'group-hover:text-[#8875D5]';

  return (
    <div className="flex items-center gap-6">
      <a
        href="https://www.tiktok.com/@trustitests"
        className="group"
        aria-label="Trusti on TikTok"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="relative flex h-10 w-10 items-center justify-center transition-all duration-300 ease-in-out group-hover:scale-110">
          <div className="absolute h-10 w-10 rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
          <TikTokIcon
            className={`relative z-10 ${baseTextColor} ${hoverColor} transition-colors duration-300 ease-in-out`}
          />
        </div>
      </a>

      <a
        href="https://bsky.app/profile/trusti.bsky.social"
        className="group"
        aria-label="Trusti on Bluesky"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="relative flex h-10 w-10 items-center justify-center transition-all duration-300 ease-in-out group-hover:scale-110">
          <div className="absolute h-10 w-10 rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
          <BlueskyIcon
            className={`relative z-10 ${baseTextColor} ${hoverColor} transition-colors duration-300 ease-in-out`}
          />
        </div>
      </a>

      <a
        href="https://www.instagram.com/trustitests/"
        className="group"
        aria-label="Trusti on Instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="relative flex h-10 w-10 items-center justify-center transition-all duration-300 ease-in-out group-hover:scale-110">
          <div className="absolute h-10 w-10 rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
          <InstagramIcon
            className={`relative z-10 ${baseTextColor} ${hoverColor} transition-colors duration-300 ease-in-out`}
          />
        </div>
      </a>

      <a
        href="http://www.youtube.com/@trustitests"
        className="group"
        aria-label="Trusti on YouTube"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="relative flex h-10 w-10 items-center justify-center transition-all duration-300 ease-in-out group-hover:scale-110">
          <div className="absolute h-10 w-10 rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
          <YouTubeIcon
            className={`relative z-10 ${baseTextColor} ${hoverColor} transition-colors duration-300 ease-in-out`}
          />
        </div>
      </a>
    </div>
  );
};

export default SocialMediaLinks;
